module.exports = __webpack_public_path__ + "img/active-success.f7956da1.png";